<template>
  <div id="q-app">
    <component :is="currentComponent" />
  </div>
</template>

<script>
const PcApp = () => import('src/pc/App.vue')
const MobileApp = () => import('src/mobile/App.vue')

export default {
  name: 'App',
  components: { PcApp, MobileApp },
  data () {
    return {
      isPC: process.env.BUILD_TARGET === 'pc'
    }
  },
  computed: {
    currentComponent () {
      return this.isPC ? 'PcApp' : 'MobileApp'
    }
  }
}
</script>

<style>
</style>
